import { Link } from 'react-router-dom';
import { useAuth } from '../lib/auth-context';
import { FleetHealthBadge } from './FleetHealthBadge';
import { NotificationBell } from './NotificationBell';
import { ThemeToggle } from './ThemeToggle';
import { OrbotoLockup } from './OrbotoLockup';

export interface NavbarProps {
  /** OCP-333 — opens the mobile nav drawer; the button shows only below md. */
  onMenuClick?: () => void;
}

export function Navbar({ onMenuClick }: NavbarProps = {}) {
  const { user, logout } = useAuth();
  return (
    <header className="flex h-14 items-center justify-between border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 px-4 sm:px-6">
      <div className="flex min-w-0 items-center gap-2 sm:gap-3">
        {onMenuClick && (
          <button
            type="button"
            onClick={onMenuClick}
            aria-label="Open menu"
            className="-ml-1 flex h-9 w-9 shrink-0 items-center justify-center rounded text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800/60 md:hidden"
          >
            <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.75">
              <path d="M4 6h16M4 12h16M4 18h16" strokeLinecap="round" />
            </svg>
          </button>
        )}
        <OrbotoLockup className="h-6 w-auto shrink-0" />
        <span className="hidden text-sm font-medium tracking-tight text-gray-500 sm:inline">
          Control Plane
        </span>
      </div>
      <div className="flex min-w-0 items-center gap-2 sm:gap-4">
        {user && <FleetHealthBadge />}
        {user && <NotificationBell />}
        {user && (
          <Link to="/security" title="Second factor and account security" className="hidden max-w-[40vw] truncate text-sm text-gray-600 hover:text-brand-500 dark:text-gray-400 sm:inline" data-testid="navbar-security">
            {user.email}
            {user.role !== 'super_admin' && <span className="ml-1 text-xs text-gray-400">({user.role})</span>}
          </Link>
        )}
        <ThemeToggle />
        <button
          type="button"
          onClick={() => {
            void logout();
          }}
          className="rounded border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 px-2.5 py-1.5 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800/60 sm:px-3"
        >
          Log out
        </button>
      </div>
    </header>
  );
}
